import { render, staticRenderFns } from "./imageInputFile.vue?vue&type=template&id=3f4da3fb&scoped=true"
import script from "./imageInputFile.vue?vue&type=script&lang=js"
export * from "./imageInputFile.vue?vue&type=script&lang=js"
import style0 from "./imageInputFile.vue?vue&type=style&index=0&id=3f4da3fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4da3fb",
  null
  
)

export default component.exports